
import React, { useState } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Play } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

// Action node component for the flow editor
export const ActionNode = ({ data, isConnectable }: any) => {
  const isMobile = useIsMobile();
  const [collapsed, setCollapsed] = useState(isMobile);
  
  return (
    <div className="bg-white border rounded-md shadow-sm p-2 w-[200px]">
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        className="w-2 h-2 rounded-full bg-green-500 border-2 border-white"
      />
      
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Play className="h-4 w-4 text-green-500" />
          <span className="font-medium text-sm truncate max-w-[130px]">{data.label}</span>
        </div>
        {isMobile && (
          <button 
            onClick={() => setCollapsed(!collapsed)}
            className="text-gray-500 hover:text-gray-700"
          >
            {collapsed ? '+' : '-'}
          </button>
        )}
      </div>
      
      {!collapsed && (
        <div className="mt-2 text-xs space-y-1 text-gray-600">
          <div className="flex justify-between">
            <span>Type:</span> 
            <span className="font-medium">{data.actionType || 'Not set'}</span>
          </div>
          <div className="flex justify-between">
            <span>Target:</span> 
            <span className="font-medium truncate max-w-[120px]">{data.target || 'Not set'}</span>
          </div>
          {data.message && (
            <div className="flex justify-between">
              <span>Message:</span> 
              <span className="font-medium truncate max-w-[120px]">{data.message}</span>
            </div>
          )}
        </div>
      )}
      
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        className="w-2 h-2 rounded-full bg-green-500 border-2 border-white"
      />
    </div>
  );
};
